<template>
    <div>
        <b-card title="Filtros">
            <div class="card-text">
                <b-row>
                    <b-col align-h="center" cols="12" md="4" lg="3">
                        <app-form-text-input placeholder="Nombre" v-model="filters.name" />
                    </b-col>
                    <b-col cols="6" md="4" lg="3">
                        <app-form-select-input
                            placeholder="Perfil"
                            :options="selectFileTypes"
                            v-model="filters.fileTypeId"
                        />
                    </b-col>
                    <b-col cols="12" md="4" lg="2">
                        <b-button variant="primary" @click="$emit('filter', filters)">
                            <i class="fa fa-filter"></i>
                        </b-button>
                        <b-button variant="secondary" @click="clearFilters">
                            <i class="fa fa-times-circle"></i>
                        </b-button>
                    </b-col>
                </b-row>
            </div>
        </b-card>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    data() {
        return {
            filters: {
                name: '',
                fileTypeId: '',
            },
            selectFileTypes: [],
        }
    },
    methods: {
        async loadFileTypes() {
            const { data } = await repo.get('file-management/file-types')
            this.selectFileTypes = data
        },
        clearFilters() {
            Object.keys(this.filters).map(key => (this.filters[key] = ''))
            this.$emit('filter', null)
        },
    },
    created() {
        this.loadFileTypes()
    },
}
</script>


